import { ReactComponent as Logo } from '../../assets/icons/credit card.svg'

const Credit = () => {
    return <Logo width={20} height={20} fill='white' />
}

export default Credit
